import { render, staticRenderFns } from "./EntityDetailedCardView.vue?vue&type=template&id=845da3be&scoped=true"
import script from "./EntityDetailedCardView.vue?vue&type=script&lang=js"
export * from "./EntityDetailedCardView.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailedCardView.vue?vue&type=style&index=0&id=845da3be&prod&lang=scss&scoped=true"
import style1 from "./EntityDetailedCardView.vue?vue&type=style&index=1&id=845da3be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845da3be",
  null
  
)

export default component.exports